import React from 'react';
import { XCircle } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Contract } from '@/types/ContractType';

interface ContractVoidedNotificationProps {
  contract: Contract;
}

export const ContractVoidedNotification: React.FC<
  ContractVoidedNotificationProps
> = ({ contract }) => {
  // Priority: seller overrides > product database (source of truth) > legacy agentSellerInfo
  const propertyAddress =
    contract?.sellerPropertyInfo?.propertyAddress ||
    contract?.product?.address?.fullAddress ||
    contract?.product?.address?.street ||
    contract?.agentSellerInfo?.propertyAddress ||
    'the property';

  return (
    <Card className="mb-6 border-red-500 bg-red-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-bold text-red-800 flex items-center gap-2">
          <XCircle className="h-5 w-5" />
          Offer Rejected
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-red-900 mt-2">
          Your offer for <strong>{propertyAddress}</strong> has been declined.
        </p>
        {contract.voidedReason && (
          <p className="text-red-900 mt-2">
            <strong>Reason:</strong> {contract.voidedReason}
          </p>
        )}
        <p className="text-red-800 text-sm mt-2">
          This contract has been voided on{' '}
          {contract.voidedAt
            ? new Date(contract.voidedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })
            : 'recently'}
          . You may search for other properties or submit a new offer.
        </p>
      </CardContent>
    </Card>
  );
};
